import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {MainService} from 'src/app/Services/service.service';
import {displayModeType} from 'src/app/Adv/search-results/search-results.component';
import {PageEvent} from '@angular/material';
import {DTOAdvertisementEx} from 'src/app/api/LocalModels';
import * as moment from "moment";
import {DTOAdvertisement, ShowAdType} from "../../api/WickedApiClient";
import {ViewMode} from "../../Services/advertisement.service";
import { AdvUserAdvertisementsComponent } from '../adv-user-advertisements/adv-user-advertisements.component';

@Component({
  selector: 'app-adv-user-advertisements-non-demo',
  templateUrl: './adv-user-advertisements-non-demo.component.html',
  styleUrls: ['./adv-user-advertisements-non-demo.component.scss']
})
export class AdvUserAdvertisementsNonDemoComponent extends AdvUserAdvertisementsComponent {

  constructor(public route: ActivatedRoute, public service: MainService) {
    super(route, service);
  }

  ngOnInit() {
    if (!this.service.userService.isAdmin()) {
      this.service.route.navigate(["/"]);
    }

    if (!this.service.userService.isDemo()) {
      this.viewMode=ViewMode.ACTIVE;
    }
    this.performSearch();
  }

  public performSearch() {
    this.service.advService.searchDataUserAdv.currentSearchRule.nonDemoOnly = true;
    this.service.advService.searchDataUserAdv.currentSearchRule.userId = null;
    this.service.advService.searchActionForUser(this.viewMode);
  }

 

  public set pageEvent(value: PageEvent) {
    this.service.advService.searchDataUserAdv.currentSearchRule.pageNumber = value.pageIndex;
    this.service.advService.searchDataUserAdv.currentSearchRule.pageSize = value.pageSize;
    this.service.advService.searchDataUserAdv.currentSearchRule.nonDemoOnly = true;
    this.service.advService.searchDataUserAdv.currentSearchRule.userId = null;
    this.service.advService.searchActionForUser(this.viewMode);
    this._pageEvent = value;
  }
}


